// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TDyNW","toggle":"styles_toggle__16A1o","preview":"styles_preview__2rICL"};